const baseURL = "https://22gxiwdppa.execute-api.ap-south-1.amazonaws.com/dev/api/ds/"

export const createRawDS = baseURL + "rawCreateDS";
export const createEndDS = baseURL + "createDeliverySchedules";
export const getRawDSByPo = baseURL + "getByPO/";
export const getEndDSByPo = baseURL + "getDeliverySchedule/";
export const updateEndDSByPo = baseURL + "updateDeliverySchedule";
